import React from 'react' 
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled/macro'
import { pulse } from 'react-animations';
import { useInView } from 'react-intersection-observer'
import { animate, View } from "../AnimationsHelper";
import { Theme2, Device } from "../Layout"
import { useFormHomeQuery } from '../../hooks/use-form-home-query'
import { Form } from '../Form';

const animation = keyframes`${pulse}`;

const FormContainer = styled.div`
position: relative;
height: 171px;
background-color: ${Theme2.colors.dark1};

@media ${Device.sm}{
    height: calc(171px + 149 * ((100vw - 576px) / 624));
}
@media ${Device.xl}{
    height: 320px;
}

svg{
    display: none;
}
.formContainerInner{
    position: absolute;
bottom: 0;
left: 50%;
transform: translateX(-50%);
background-color: ${Theme2.colors.light};
padding: 1.5em;
box-sizing: border-box;
width: 90%;
max-width: 378px;

@media ${Device.lg}{
    padding: 2em;
    max-width: 1200px;
}
}
button{
    width: 100%;
    border: none;
    appearance: none;
    background-color: ${Theme2.colors.tertiary};
    color: ${Theme2.colors.light};
    border-radius: 5px;
    margin-top: 10px;
    padding: 5px 0;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 600;
    display: block;
    box-sizing: border-box;
    transition: all .25s;

    &:hover{
        background-color: ${Theme2.colors.light2};
        color: ${Theme2.colors.dark1};
        cursor: pointer;
    }
    @media ${Device.lg}{
        grid-column: 1 / span 2;
        padding: 15px 0;
        margin-top: 20px;
    }
}
button p{
    margin: 0;
}
.title{
    text-align: center;
    font-family: ${Theme2.fonts.headings};
    font-size: 35px;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 1rem;

    @media ${Device.sm}{
        font-size: calc(35px + 45 * ((100vw - 576px) / 624));
    }
    @media ${Device.lg}{
        margin-bottom: 2rem;
    }
    @media ${Device.xl}{
        font-size: 80px;
    }
    &.animate {
					animation: 1s ${animation};
				}
}

input, textarea{
    resize: none;
    width: 100%;
    box-sizing: border-box;
    background-color: ${Theme2.colors.blogBackgroundColor};
    border: 1px solid ${Theme2.colors.neutral};
    border-radius: 2px;
    padding: .5rem;

    @media ${Device.lg}{
        padding: 1rem;
        border-radius: 5px;
    }
}
textarea{
    @media ${Device.lg}{
        grid-column: 1 / span 2;
    }
}
.formFieldsGridContainer{
    display: grid;
    grid-gap: 7px;

    @media ${Device.lg}{
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
    }
}
.error:empty{
    display: none;
}
`

const HomeFormContainer = () => {
    const data = useFormHomeQuery()
    const [ref, inView] = useInView(View)
    return(
<FormContainer ref={ref} id="free-consult">
    <div className="formContainerInner">
        <p className={"title "+animate(inView)}>
            {data.formHeading}
        </p>
    <Form />
    </div>
  
</FormContainer>
    )
}
export default HomeFormContainer